export class AddressDTO {
    public street: string;
    public number: string;
    public complement: string;
    public neighborhood: string;
    public zipCode: string;
    public country: string;
    public state: string;
    public city: string;

    constructor(obj?) {
        obj = obj || {};
        this.street = obj.street || null;
        this.number = obj.number || null;
        this.complement = obj.complement || null;
        this.neighborhood = obj.neighborhood || null;
        this.zipCode = obj.zipCode || null;
        this.country = obj.country || null;
        this.state = obj.state || null;
        this.city = obj.city || null;
    }
}
